import { BrowserRouter as Router, Routes, Route, UNSAFE_NavigationContext } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Hero } from './components/home/Hero';
import { Skills } from './components/about/Skills';
import { ProjectCard } from './components/projects/ProjectCard';
import { ContactForm } from './components/contact/ContactForm';
import { ChatBot } from './components/chat/ChatBot';
import { ChatBotProvider } from './context/ChatBotContext';

// Pages
const Home = () => <Hero />;

const About = () => (
  <div className="pt-16">
    <Skills />
  </div>
);

const Projects = () => (
  <div className="pt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-12">
      Mes Projets
    </h1>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
      <ProjectCard
        title="ChatBot IA Personnel"
        description="Un chatbot intelligent développé avec React et l'API Hugging Face, capable de répondre aux questions sur mon profil professionnel et mes compétences. Il possède un mode agent qui me permet de réaliser des actions spécifiques comme : <br />
        - Rediriger vers une page selon le contexte <br />
        - Proposer le téléchargement de mon CV si demandé <br />
        - Proposer la redirection vers mon profil LinkeDin si nécéssaire <br />
        Intégré à mon portfolio, il offre une expérience interactive aux visiteurs."
        image="/images/omarIA.png"
        technologies={['React', 'TypeScript', 'Node.js', 'Open AI API', 'Tailwind CSS']}
        demoUrl="https://omarbelaid.fr"
        isChatBot={true}
      />
      <ProjectCard
        title="X14 - Logiciel de Gestion Locative"
        description="En tant que développeur full stack chez Orisha, j'ai participé au développement, à la maintenance et à l'évolution de X14, une application web complète de gestion locative. J'ai contribué à l'amélioration continue des fonctionnalités : gestion des biens, des locataires, des propriétaires, des paiements et de la comptabilité. J'ai également optimisé les performances et l'expérience utilisateur de l'interface."
        image="/images/computer2.jpg"
        technologies={['Angular', 'PHP', 'Zend', 'MySQL', 'Docker', 'GitLab', 'AWS']}
        demoUrl="https://realestate.orisha.com/nos-solutions/x14-gerance/"
      />
      <ProjectCard
        title="Y15 - Solution de Gestion de Copropriété"
        description="Au sein de l'équipe Orisha, j'ai contribué à l'évolution et à la maintenance de Y15, une plateforme web innovante pour la gestion de copropriété. J'ai développé de nouvelles fonctionnalités et optimisé les modules existants : gestion des assemblées générales, des charges, de la comptabilité et de la maintenance des immeubles. J'ai également participé à l'amélioration de l'extranet copropriétaires."
        image="/images/computer.jpg"
        technologies={['Angular', 'KnockoutJS', 'PHP', 'MySQL', 'Docker', 'GitLab', 'AWS']}
        demoUrl="https://realestate.orisha.com/nos-solutions/y15-syndic/"
      />
      <ProjectCard
        title="Site Vitrine pour 'La Beauté de l'homme'"
        description="Un site élégant conçu pour mettre en valeur les services de beauté masculins, intégrant également Planity pour la gestion des rendez-vous, Instagram pour les photos et Google Reviews."
        image="/images/labeautedelhomme.png"
        technologies={['WordPress', 'Elementor', 'Planity', 'Instagram', 'Google Reviews']}
        demoUrl="https://www.labeautedelhomme.net/"
      />
    </div>
  </div>
);

const Contact = () => (
  <div className="pt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-12">
      Contactez-moi
    </h1>
    <ContactForm />
  </div>
);

export const App = () => {
  return (
    <ChatBotProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="min-h-screen bg-gray-50/90 dark:bg-gray-900/90">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ChatBotProvider>
  );
};
